<template>
    <backend-layout title="Influencers" create="referrer">
        <div class=" has-table md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800 mb-6"
             v-if="referrers.data.length > 0">
            <header class="card-header">
                <p class="card-header-title">
                    <span class="icon"><i class="mdi mdi-account-multiple"></i></span>
                    Influencers
                </p>
            </header>
            <div class="card-content">
                <table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <!--                        <th>Code</th>-->
                        <th>Campaigns</th>
                        <!--                        <th>Contact</th>-->
                        <th>Contact</th>
                                                <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="referrer in referrers.data">
                        <td data-label="Name">{{ referrer.name }}</td>
                        <td data-label="Campaigns">
                            <div class="">
                                <div class="relative">
                                    <select
                                        :class="{'appearance-none':referrer.campaigns.length < 2}"
                                        class="px-3 py-2 max-w-full focus:ring focus:outline-none border-0 rounded w-full dark:placeholder-gray-400 h-12 border bg-white dark:bg-gray-800">
                                        <template v-if="referrer.campaigns.length === 0">
                                            <option>
                                                --None--
                                            </option>
                                        </template>
                                        <template v-else>
                                            <option v-for="campaign in referrer.campaigns" value="">{{campaign.name}}
                                            </option>
                                        </template>

                                    </select>
                                    <span v-if="referrer.campaigns.length > 1"
                                          class="text-sm dark:text-gray-500 absolute top-3 right-8 px-2 z-10">+{{referrer.campaigns.length - 1}} more</span>
                                </div>
                            </div>
                        </td>
                                                <td data-label="Contact">
                                                    {{this.referrerContact(referrer)}}
                                                </td>
<!--                        <td data-label="Contact">-->
<!--                            <small class="text-gray-500"-->
<!--                                   title="Oct 25, 2021">{{ new Date(referrer.created_at).toDateString() }}</small>-->
<!--                        </td>-->
                        <!--                        <td class="actions-cell">-->
                        <!--                            <div class="buttons right nowrap">-->
                        <!--                                <button class="button small green &#45;&#45;jb-modal" data-target="sample-modal-2"-->
                        <!--                                        type="button">-->
                        <!--                                    <span class="icon"><i class="mdi mdi-eye"></i></span>-->
                        <!--                                </button>-->
                        <!--                                <button class="button small red &#45;&#45;jb-modal" data-target="sample-modal"-->
                        <!--                                        type="button">-->
                        <!--                                    <span class="icon"><i class="mdi mdi-trash-can"></i></span>-->
                        <!--                                </button>-->
                        <!--                            </div>-->
                        <!--                        </td>-->
                        <td class="actions-cell">
                            <div class="buttons right nowrap">
                                <a :href="route('referrers.analytics',{'code':referrer.username})"
                                   class="button bg-pink-700 text-white" title="Analytics"
                                   type="button">
                                    <span class="icon"><i class="mdi mdi-chart-areaspline"></i></span>
                                </a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <pagination :links="referrers.links" :active-page="referrers.current_page"
                            :total-pages="referrers.total"></pagination>
            </div>
        </div>
        <div v-else>
            No Referrers Available
        </div>
    </backend-layout>
</template>

<script>
import BackendLayout from "@/Layouts/BackendLayout";
import Pagination from "@/Components/Pagination";

export default {
    props: {
        referrers: Object
    },
    components: {Pagination, BackendLayout},
    methods: {
        referrerContact(referrer) {
            return referrer.phone ?? referrer.email;
        }
    }
}
</script>

<style scoped>
.appearance-none {
    -webkit-appearance: none;
    -moz-appearance:    none;
    appearance: none;
    background: none;
}
</style>
